import { Box, Card, Heading, P, Tag, formatDate } from '@veracity/vui'

import { CalculationStates, ProjectSimple } from '@/interfaces'

interface Props {
  project: ProjectSimple
}
export const ProjectInfoCard = ({ project }: Props) => {
  const subtitleText = [
    project.createdBy,
    project.company,
    formatDate(project.createdAt, 'DD MM YYYY')
  ]
    .filter(Boolean)
    .join(', ')

  const getProjectStatusCount = (
    project: ProjectSimple,
    statuses: CalculationStates[]
  ) =>
    project.scenarios?.map(x => x.state).filter(x => statuses.includes(x))
      .length

  const notSetCount = getProjectStatusCount(project, [CalculationStates.NotSet])

  const failedCount = getProjectStatusCount(project, [CalculationStates.Error])

  const passedCount = getProjectStatusCount(project, [
    CalculationStates.Finished
  ])

  const cancelledCount = getProjectStatusCount(project, [
    CalculationStates.Canceled
  ])

  const inProgressCount = getProjectStatusCount(project, [
    CalculationStates.InProgress,
    CalculationStates.Preprocessing
  ])

  return (
    <Card column p={1} h="100%" isInteractive justify="space-between">
      <Box column gap={1}>
        <Box w="100%" gap={1} justify="space-between">
          <Heading w="70%" isTruncated size="h5" title={project.name}>
            {project.name}
          </Heading>
          <Tag isRound text={project.isoBaName} />
        </Box>
        <P>{subtitleText}</P>
      </Box>
      <Box gap={1} h={30}>
        {!!notSetCount && (
          <Tag
            isRound
            variant="subtleGrey"
            text={notSetCount}
            title="New calculations"
          />
        )}
        {!!inProgressCount && (
          <Tag
            isRound
            text={inProgressCount}
            title="Calculations in progress"
          />
        )}
        {!!failedCount && (
          <Tag
            isRound
            variant="subtleRed"
            text={failedCount}
            title="Failed calculation"
          />
        )}
        {!!passedCount && (
          <Tag
            isRound
            variant="subtleGreen"
            text={passedCount}
            title="Passed calculations"
          />
        )}

        {!!cancelledCount && (
          <Tag
            isRound
            variant="subtleYellow"
            text={cancelledCount}
            title="Cancelled calculations"
          />
        )}
      </Box>
    </Card>
  )
}
